import React, { useState } from "react";
import { Badge, Modal, Secret } from "@frontrunners/ui-components";
import CustomButton from "../../../../common/CustomButton";
import { COGNITO_ACCESS_TOKEN_KEY } from "../../../../common/authHelper";

export const ResetUserPasswordModal = ({ user, endpoints, onClose }) => {
  const [newPassword, setNewPassword] = useState(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async () => {
    setIsLoading(true);
    setError(false);
    try {
      const accessToken = window.localStorage.getItem(COGNITO_ACCESS_TOKEN_KEY);
      const url = `${endpoints.apiHost}/internal/v1/identity-management/users/${user.id}/set-password`;
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, options);
      const res = await response.json();
      if (response.status !== 200) {
        setError(res);
      } else {
        setNewPassword(res.password);
      }
    } catch (err) {
      setError({ reason: "Failed to reset password" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <h1 style={{ marginTop: 30 }}>
        This will reset the password for the <Badge className="warning">{user.email}</Badge>user
      </h1>
      <p>
        By performing this action, the user's current password will immediately stop working. You will receive a
        one-time password that can only be used once, and it should be used by the user. Be cautious!
      </p>

      {newPassword && (
        <Secret
          secret={newPassword}
          showSecretLabelText="Show secret"
          copyButtonHoverText="Copy to clipboard"
          copyButtonClickText="Copied!"
        />
      )}

      {!newPassword && (
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          <CustomButton variant="default" onClick={handleResetPassword} loading={isLoading}>
            Yes, reset password
          </CustomButton>
          <CustomButton variant="text" onClick={onClose} disabled={isLoading}>
            Cancel
          </CustomButton>
        </div>
      )}
      {error && <div className="error">{error.reason}</div>}
    </Modal>
  );
};
